(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review-heighlight"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rhl-links')) {
    class RhlLinks extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const link = event.target.closest('[data-rhl-link]');
          if (!link || !this.contains(link)) return;

          const target = this.findTarget(link);
          if (!target) return; /* not found: leave the normal anchor behaviour */

          event.preventDefault();
          this.scrollToTarget(target);
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.onClick) this.removeEventListener('click', this.onClick);
      }

      findTarget(link) {
        const id = (link.getAttribute('href') || '').replace(/^#/, '');
        let target = id ? document.getElementById(id) : null;
        if (!target) {
          target = document.querySelector('.jdgm-rev-widg, .jdgm-review-widget, .jdgm-widget');
        }
        return target;
      }

      scrollToTarget(target) {
        const offset = parseInt(this.getAttribute('data-offset'), 10) || 0;
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });

        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }
    customElements.define('rhl-links', RhlLinks);
  }
  } catch(e) { console.error(e); }
})();

})();
